export default {
  methods: {
    scrollTo(ref) {
      const element = document.querySelector(`${ref}`);
      const offset = element.offsetTop;
      window.scroll({
        top: offset,
        left: 0,
        behavior: 'smooth',
      });
    },
  },
};
